import Kayaba from './Kayaba'

export default Kayaba
